<template>
  <v-container>
    <v-subheader class="title" id="devices__main-title">
      <v-icon x-large class="mr-2">mdi-devices</v-icon>
      {{ $t("modules.devices.title") }}
    </v-subheader>
    <v-divider></v-divider>
    <div v-if="isPermitted(PermissionEnum.DEVICES.VIEW)">
      <devices-action></devices-action>
      <devices-table :headers="table.headers" css-class="mx-2"></devices-table>
    </div>
    <div v-else class="grey--text">
      <v-container fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <div>
              <v-icon size="50" color="grey">mdi-alert</v-icon>
            </div>
            <h3 class="display-1 font-weight-light">
              {{ $t("validation.notPermitted") }}
            </h3>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <rf-recording-dialog
      :disabled="!isPermitted(PermissionEnum.RF_RECORDINGS.VIEW)"
    ></rf-recording-dialog>
    <status-message></status-message>
  </v-container>
</template>

<script>
import DevicesTable from "./components/devices-table";
import DevicesAction from "./components/devices-action";
import StatusMessage from "@/components/status-message";
import RfRecordingDialog from "./components/rf-recordings-dialog";
import { handleError } from "@/utils/error";
import { periodicCall } from "@/utils";
import { permissionMixin } from "@/mixins/permissions.js";
import constants from "@/utils/constants";

export default {
  name: "DevicesPage",
  mixins: [permissionMixin],
  components: {
    StatusMessage,
    DevicesAction,
    DevicesTable,
    RfRecordingDialog
  },

  data() {
    return {
      table: {
        headers: [
          {
            text: this.$t("modules.devices.name"),
            align: "left",
            value: "name"
          },
          {
            text: this.$t("modules.devices.pairing_id"),
            align: "left",
            value: "pairing_id"
          },
          {
            text: this.$t("modules.devices.version"),
            align: "center",
            value: "versions"
          },
          {
            text: this.$t("modules.devices.server"),
            align: "center",
            value: "is_server"
          },
          {
            text: this.$t("modules.devices.activated"),
            align: "center",
            value: "is_activated"
          },
          {
            text: this.$t("modules.devices.enabled"),
            align: "center",
            value: "is_enabled"
          },
          {
            text: this.$t("modules.devices.membership"),
            align: "left",
            value: "membership"
          },
          {
            text: this.$t("actions.actions"),
            align: "center",
            value: "action",
            sortable: false
          }
        ]
      },
      intervalId: null
    };
  },

  created() {
    this.$store.commit("snackbar/toggleMessage", false);
    if (this.isPermitted(this.PermissionEnum.DEVICES.VIEW)) {
      this.intervalId = periodicCall(
        this.fetchDevicesState,
        constants.REQUEST_INTERVAL_IN_MILLISECONDS
      );
    }
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
  methods: {
    fetchDevicesState() {
      this.$store
        .dispatch("devices/fetchDevicesState")
        .catch(error => handleError(error));
    }
  }
};
</script>
